import React, {useEffect, useState} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import UiInputMoney from "../components/Form/UiInputMoney";
import UiInputNumberInteger from "../components/Form/UiInputNumberInteger";
import UiInputDate from "../components/Form/UiInputDate";
import UiGridFormTable from "../components/Form/UiGridFormTable";
import CepAutocompleteWrapper from "../components/Form/CepAutocompleteWrapper";
import {get} from "../services/ApiService";
import moment from "moment";

export default function BoletoForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { numeroParcelas: 1 }
    });
    const { handleSubmit, watch, setValue, reset } = methods;
    const allData = watch();
    const [cepLoading, setCepLoading] = useState(false);
    const [gatewayList, setGatewayList] = useState<any[]>([]);

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    useEffect(() => {
        const carregarGateways = async () => {
            try {
                const response = await get('/?route=boleto/form&action=gatewayPagamentoList');
                if (response.status === 200 && response.data.success) {
                    setGatewayList(response.data.payload);
                }
            } catch (error) {
                console.error('Erro ao carregar gateways:', error);
            }
        };
        carregarGateways();
    }, []);

    const gerarParcelas = (numeroParcelas: number, valorTotal: any) => {
        const valor = parseFloat(valorTotal) || 0;
        if (!numeroParcelas || numeroParcelas < 1) return [];
        if (!valor || valor <= 0) return [];
        valorTotal = valor;

        const valorParcela = parseFloat((valorTotal / numeroParcelas).toFixed(2));
        const parcelas = [];
        const primeiraParcela = moment().add(1, 'month').date(15);

        for (let i = 1; i <= numeroParcelas; i++) {
            parcelas.push({
                numero: i,
                dataVencimento: primeiraParcela.clone().add(i - 1, 'month').format('YYYY-MM-DD'),
                valor: valorParcela
            });
        }

        const somaCalculada = parcelas.reduce((sum, p) => sum + p.valor, 0);
        const diferenca = valorTotal - somaCalculada;
        if (diferenca !== 0 && parcelas.length > 0) {
            parcelas[parcelas.length - 1].valor = parseFloat((parcelas[parcelas.length - 1].valor + diferenca).toFixed(2));
        }

        return parcelas;
    };

    const carregarDadosContrato = async (contrato: any) => {
        if (!contrato || !contrato.id) return;

        try {
            const response = await get(`/?route=boleto/form&action=buscarDadosContrato&contratoId=${contrato.id}`);
            if (response.status === 200 && response.data?.success) {
                const dados = response.data.data;

                if (dados.pagadorNome) setValue('pagadorNome', dados.pagadorNome);
                if (dados.pagadorCpfCnpj) setValue('pagadorCpfCnpj', dados.pagadorCpfCnpj);

                if (dados.pagadorEndereco) {
                    setValue('pagadorEndereco.endereco', dados.pagadorEndereco.endereco);
                    setValue('pagadorEndereco.numero', dados.pagadorEndereco.numero);
                    setValue('pagadorEndereco.bairro', dados.pagadorEndereco.bairro);
                    setValue('pagadorEndereco.cidade', dados.pagadorEndereco.cidade);
                    setValue('pagadorEndereco.cep', dados.pagadorEndereco.cep);
                }

                if (dados.parcelas && dados.parcelas.length > 0) {
                    setValue('parcelas', dados.parcelas);
                    setValue('numeroParcelas', dados.parcelas.length);
                    const valorTotal = dados.parcelas.reduce((sum: number, p: any) => sum + (parseFloat(p.valor) || 0), 0);
                    setValue('valorTotal', valorTotal);
                } else if (dados.valorTotal) {
                    setValue('valorTotal', dados.valorTotal);
                }
            }
        } catch (error) {
            console.error('Erro ao carregar dados do contrato:', error);
        }
    };

    useEffect(() => {
        if (allData.contrato?.id) {
            carregarDadosContrato(allData.contrato);
        }
    }, [allData.contrato?.id]);

    useEffect(() => {
        const numeroParcelas = allData.numeroParcelas;
        const valorTotal = allData.valorTotal;

        if (numeroParcelas && valorTotal) {
            setValue('parcelas', gerarParcelas(numeroParcelas, valorTotal));
        }
    }, [allData.numeroParcelas, allData.valorTotal]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <CepAutocompleteWrapper
                        cepField="pagadorEndereco.cep"
                        enderecoField="pagadorEndereco.endereco"
                        bairroField="pagadorEndereco.bairro"
                        cidadeField="pagadorEndereco.cidade"
                        numeroField="pagadorEndereco.numero"
                        onLoadingChange={setCepLoading}
                    />
                    <div className="row">
                        <div className="col-lg-12">
                                <div className="row">
                                    <UiInputSuggest
                                        size={4}
                                        router="contrato"
                                        idField="id"
                                        titleField="cli_nome"
                                        name="contrato"
                                        label="Contrato"
                                    />

                                    {gatewayList.length > 0 && <UiInputList
                                        size={3}
                                        name="gateway"
                                        list={gatewayList}
                                        idField="id"
                                        titleField="title"
                                        label="Gateway"
                                    />}

                                    <UiInputMoney
                                        size={3}
                                        name="valorTotal"
                                        label="Valor Total"
                                    />

                                    <UiInputNumberInteger
                                        size={2}
                                        min={1}
                                        max={24}
                                        name="numeroParcelas"
                                        label="N° Parcelas"
                                    />
                                </div>
                        </div>

                        <div className="col-lg-12">
                            <fieldset>
                                <legend>Pagador</legend>
                                <div className="row">
                                    <UiInputText
                                        mask={"uppercase"}
                                        size={8}
                                        name="pagadorNome"
                                        label="Nome/Razão Social"
                                    />

                                    <UiInputText
                                        mask={"cpfCnpj"}
                                        size={4}
                                        name="pagadorCpfCnpj"
                                        label="CPF/CNPJ"
                                    />

                                    <UiInputText
                                        mask={"cep"}
                                        size={2}
                                        name="pagadorEndereco.cep"
                                        label="CEP"
                                        loading={cepLoading}
                                    />

                                    <UiInputText
                                        mask={"uppercase"}
                                        size={5}
                                        name="pagadorEndereco.endereco"
                                        label="Endereço"
                                    />

                                    <UiInputText
                                        size={2}
                                        name="pagadorEndereco.numero"
                                        label="Número"
                                        showDisableCheckbox={true}
                                        onDisableSetValue="S/N"
                                        disableButtonLabel="S/N"
                                    />

                                    <UiInputText
                                        mask={"uppercase"}
                                        size={3}
                                        name="pagadorEndereco.complemento"
                                        label="Complemento"
                                    />

                                    <UiInputText
                                        mask={"uppercase"}
                                        size={3}
                                        name="pagadorEndereco.bairro"
                                        label="Bairro"
                                    />

                                    <UiInputSuggest
                                        size={5}
                                        router="cidade"
                                        idField="id"
                                        titleField="nome"
                                        name="pagadorEndereco.cidade"
                                        label="Cidade"
                                    />
                                </div>
                            </fieldset>
                        </div>

                        <div className="col-lg-12">
                            <UiGridFormTable name="parcelas" label="Configuração das Parcelas">
                                <UiInputNumberInteger asTable={true} size={2} name="numero" label="Nº"/>
                                <UiInputDate asTable={true} size={5} dateFormat="dd/mm/yy" name="dataVencimento" label="Vencimento"/>
                                <UiInputMoney asTable={true} size={5} name="valor" label="Valor"/>
                            </UiGridFormTable>
                        </div>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Emitir Boleto(s)</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
